<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :item-text="itemText"
    :item-value="itemValue"
    :value="value"
    append-icon='mdi-chevron-down'
    @input="update"
    outlined
    dense
    :class="['select', size]"
  >
    <template v-slot:item="{ item, on, attrs }" class="pr-3">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-icon class="mr-2">
          <v-icon :style="{ color: value === item[itemValue] ? 'var(--v-primary-base)' : '#D9DBE9' }">
            {{ value === item[itemValue] ? 'mdi-record-circle' : 'mdi-checkbox-blank-circle' }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="item[itemText]"
            class="text-left"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>

</template>

<script>

export default {
  name: 'Select',
  props: [
    'size',
    'value',
    'itemText',
    'itemValue'
  ],
  emits: ['input'],
  methods: {
    update (val) {
      this.$emit('input', val)
    }
  }
}

</script>

<style lang="scss" scoped>
  .select {
    height: 34px;
    width: 185px;
    margin-right: 0px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .xx-small {
    width: 115px;
  }
  .x-small {
    width: 145px;
  }
  .small {
    width: 165px;
  }
  .regular {
    width: 185px;
  }
  .large {
    width: 215px;
  }
  .x-large {
    width: 240px;
  }
  .xx-large {
    width: 284px;
  }
  .xxx-large {
    width: 349px;
  }
  .fullWidth {
    width: 100%;
  }

</style>
